/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Upgrade_CtaInputs */

const en_settings_upgrade_cta = /** @type {(inputs: Settings_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all plans`)
};

const id_settings_upgrade_cta = /** @type {(inputs: Settings_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua paket`)
};

/**
* | output |
* | --- |
* | "See all plans" |
*
* @param {Settings_Upgrade_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_upgrade_cta = /** @type {((inputs?: Settings_Upgrade_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Upgrade_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_upgrade_cta(inputs)
	return en_settings_upgrade_cta(inputs)
});